module.exports = __webpack_public_path__ + "media/images/footer_logo-f36716162121f15ea3b373486a026156.png";